export default __webpack_public_path__ + "static/6643-eeee0d4737e4f23bdfcd7d4e2254c36d.jpg";